import React from "react";
import Icon from "components/AppIcon";
import { useNavigate } from "react-router-dom";

/**
 * Displays a plan limit error banner with an upgrade CTA.
 * Props:
 *   message: string — the limit error message
 */
export default function PlanLimitBanner({ message }) {
  const navigate = useNavigate();
  if (!message) return null;
  return (
    <div className="flex items-start gap-3 p-3 bg-[var(--color-warning)]/10 border border-[var(--color-warning)]/30 rounded-md">
      <div className="flex-shrink-0 mt-0.5">
        <Icon name="AlertTriangle" size={15} color="var(--color-warning)" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-medium text-[var(--color-foreground)] font-[var(--font-caption)]">{message}</p>
        <button
          type="button"
          onClick={() => navigate("/vendor-plan-selection")}
          className="mt-1.5 inline-flex items-center gap-1 text-xs font-semibold text-[var(--color-primary)] hover:text-[var(--color-secondary)] transition-colors font-[var(--font-caption)]"
        >
          <Icon name="ArrowUpCircle" size={12} color="currentColor" />
          Upgrade Plan
        </button>
      </div>
    </div>
  );
}
